// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Moment = require("moment");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var SurveyResponseWindow$ReactHooksTemplate = require("./surveyResponseWindow.res.js");
var ConfigurationSettingCard$ReactHooksTemplate = require("../common/ConfigurationSettingCard.res.js");

function SurveyResponseWindows(props) {
  var __compact = props.compact;
  var __enforceable = props.enforceable;
  var onChange = props.onChange;
  var enforced = props.enforced;
  var enforce = props.enforce;
  var setting = props.setting;
  var enforceable = __enforceable !== undefined ? __enforceable : true;
  var compact = __compact !== undefined ? __compact : false;
  var match = React.useState(function (param) {
        return 1;
      });
  var $$setInterval = match[1];
  var match$1 = React.useState(function (param) {
        var storedHours = SurveyResponseWindow$ReactHooksTemplate.value(setting);
        if (storedHours >= 24 && storedHours % 24 === 0) {
          return "Day";
        } else {
          return "Hour";
        }
      });
  var setIntervalType = match$1[1];
  var intervalType = match$1[0];
  var intervalInSettings = Moment.duration(SurveyResponseWindow$ReactHooksTemplate.value(setting), "hours");
  var value;
  value = intervalType === "Day" ? intervalInSettings.asDays() : intervalInSettings.asHours();
  var onExpirationDurationChange = function ($$event) {
    var value = Belt_Int.fromString(Utils$ReactHooksTemplate.formTargetValue($$event));
    if (value === undefined) {
      return ;
    }
    var interval;
    interval = intervalType === "Day" ? "days" : "hours";
    var delay = Moment.duration(value, interval).asHours();
    Curry._2(onChange, {
          TAG: "SurveyResponseWindow",
          _0: SurveyResponseWindow$ReactHooksTemplate.setValue(setting, delay | 0)
        }, enforce);
    Curry._1($$setInterval, (function (param) {
            return value;
          }));
  };
  var handleExpirationUnitChange = function ($$event) {
    var selectedUnit = Utils$ReactHooksTemplate.formTargetValue($$event);
    var match;
    switch (selectedUnit) {
      case "days" :
          match = [
            "Day",
            "days",
            1
          ];
          break;
      case "hours" :
          var rounded = Math.round(value) | 0;
          var currentNumber = rounded < 1 ? 1 : rounded;
          match = [
            "Hour",
            "hours",
            currentNumber
          ];
          break;
      default:
        match = [
          "Hour",
          "hours",
          1
        ];
    }
    var newNumber = match[2];
    var newIntervalType = match[0];
    Curry._1(setIntervalType, (function (param) {
            return newIntervalType;
          }));
    Curry._1($$setInterval, (function (param) {
            return newNumber;
          }));
    var delayInHours = Moment.duration(newNumber, match[1]).asHours();
    Curry._2(onChange, {
          TAG: "SurveyResponseWindow",
          _0: SurveyResponseWindow$ReactHooksTemplate.setValue(setting, delayInHours | 0)
        }, enforce);
  };
  if (compact) {
    var tmp;
    tmp = intervalType === "Day" ? "days" : "hours";
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h3", {
                                children: "Survey Response Window",
                                className: ConfigurationSettingCard$ReactHooksTemplate.titleClass(undefined)
                              }),
                          JsxRuntime.jsx("p", {
                                children: "Set the time window for survey responses to be considered valid",
                                className: ConfigurationSettingCard$ReactHooksTemplate.descriptionClass(undefined)
                              })
                        ],
                        className: "min-w-0"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("input", {
                                className: "w-20 h-40-px rounded-lg border px-3 text-sm transition-colors duration-200 focus:border-pigmentblue focus:outline-none " + (
                                  enforced ? "border-gray-300 bg-gray-100 text-gray-500 cursor-not-allowed" : "border-gray-300 bg-white"
                                ),
                                disabled: enforced,
                                min: "1",
                                type: "number",
                                value: String(value),
                                onChange: onExpirationDurationChange
                              }),
                          JsxRuntime.jsxs("select", {
                                children: [
                                  JsxRuntime.jsx("option", {
                                        children: "hours",
                                        value: "hours"
                                      }),
                                  JsxRuntime.jsx("option", {
                                        children: "days",
                                        value: "days"
                                      })
                                ],
                                className: "h-40-px rounded-lg border px-3 text-sm transition-colors duration-200 focus:border-pigmentblue focus:outline-none " + (
                                  enforced ? "border-gray-300 bg-gray-100 text-gray-500 cursor-not-allowed" : "border-gray-300 bg-white"
                                ),
                                disabled: enforced,
                                value: tmp,
                                onChange: handleExpirationUnitChange
                              })
                        ],
                        className: "mt-3 flex items-center gap-2"
                      }),
                  enforceable ? JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                checked: enforce,
                                disabled: enforced,
                                label: "Enforce Policy",
                                handleChange: (function (param) {
                                    if (!enforced) {
                                      return Curry._2(onChange, {
                                                  TAG: "SurveyResponseWindow",
                                                  _0: setting
                                                }, !enforce);
                                    }
                                    
                                  }),
                                checkboxClassName: "custom_checkbox",
                                labelClassName: "text-xs font-medium text-darkcharcoal"
                              }),
                          className: "mt-3 pt-3 border-t border-gray-200"
                        }) : null,
                  enforced ? JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("span", {
                                  children: "🔒"
                                }),
                            JsxRuntime.jsx("span", {
                                  children: "Enforced by administrator"
                                })
                          ],
                          className: "mt-3 flex items-center gap-1.5 text-xs text-aurometalsaurus"
                        }) : null
                ],
                className: ConfigurationSettingCard$ReactHooksTemplate.compactCardClass(enforced, undefined)
              });
  }
  var tmp$1;
  tmp$1 = intervalType === "Day" ? "days" : "hours";
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("span", {
                                      children: "⏰",
                                      className: "text-lg"
                                    }),
                                JsxRuntime.jsx("h2", {
                                      children: "Survey Response Window",
                                      className: "text-base font-semibold text-gray-900"
                                    }),
                                enforced ? JsxRuntime.jsx("span", {
                                        children: "🔒 Enforced",
                                        className: "text-xs font-medium text-blue-700 bg-blue-100 px-2 py-1 rounded-full"
                                      }) : null
                              ],
                              className: "flex items-center space-x-2"
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Set the time window for survey responses to be considered valid",
                              className: "text-sm text-gray-600 mt-1"
                            })
                      ],
                      className: "bg-gradient-to-r from-orange-50 to-red-50 px-5 py-4 border-b border-gray-100"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("span", {
                                                            children: "Response Window:",
                                                            className: "text-sm font-medium text-gray-800"
                                                          }),
                                                      JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsx("input", {
                                                                    className: "w-20 h-10 border rounded-lg px-3 py-2 text-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent " + (
                                                                      enforced ? "border-gray-300 bg-gray-100 text-gray-500 cursor-not-allowed" : "border-gray-300 bg-white hover:border-gray-400"
                                                                    ),
                                                                    disabled: enforced,
                                                                    min: "1",
                                                                    type: "number",
                                                                    value: String(value),
                                                                    onChange: onExpirationDurationChange
                                                                  }),
                                                              JsxRuntime.jsxs("select", {
                                                                    children: [
                                                                      JsxRuntime.jsx("option", {
                                                                            children: "hours",
                                                                            value: "hours"
                                                                          }),
                                                                      JsxRuntime.jsx("option", {
                                                                            children: "days",
                                                                            value: "days"
                                                                          })
                                                                    ],
                                                                    className: "h-10 border rounded-lg px-3 py-2 text-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent " + (
                                                                      enforced ? "border-gray-300 bg-gray-100 text-gray-500 cursor-not-allowed" : "border-gray-300 bg-white hover:border-gray-400"
                                                                    ),
                                                                    disabled: enforced,
                                                                    value: tmp$1,
                                                                    onChange: handleExpirationUnitChange
                                                                  })
                                                            ],
                                                            className: "flex items-center space-x-2"
                                                          })
                                                    ],
                                                    className: "flex items-center flex-wrap gap-2"
                                                  }),
                                              JsxRuntime.jsx("span", {
                                                    children: "Active",
                                                    className: "inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full"
                                                  })
                                            ],
                                            className: "flex flex-col sm:flex-row sm:items-center gap-3"
                                          }),
                                      className: "flex-1 min-w-0"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: enforceable ? JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                    checked: enforce,
                                                    disabled: enforced,
                                                    label: "Enforce Policy",
                                                    handleChange: (function (param) {
                                                        if (!enforced) {
                                                          return Curry._2(onChange, {
                                                                      TAG: "SurveyResponseWindow",
                                                                      _0: setting
                                                                    }, !enforce);
                                                        }
                                                        
                                                      }),
                                                    checkboxClassName: "custom_checkbox",
                                                    labelClassName: "text-sm font-medium text-gray-700 whitespace-nowrap"
                                                  }),
                                              className: "flex items-center space-x-2 px-4 py-2.5 rounded-lg " + (
                                                enforce ? "bg-blue-50 border border-blue-200" : "bg-gray-50 border border-gray-200"
                                              )
                                            }) : null,
                                      className: "flex-shrink-0"
                                    })
                              ],
                              className: "flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4"
                            }),
                        enforced ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("span", {
                                              children: "⚠️",
                                              className: "text-sm flex-shrink-0"
                                            }),
                                        JsxRuntime.jsx("p", {
                                              children: "This setting is enforced and cannot be modified",
                                              className: "text-xs font-medium text-amber-900"
                                            })
                                      ],
                                      className: "flex items-start space-x-2"
                                    }),
                                className: "mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg"
                              }) : null
                      ],
                      className: "p-5"
                    })
              ]
            });
}

var make = SurveyResponseWindows;

exports.make = make;
/* react Not a pure module */
